// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"6ac5f296","510":"75e74c4a"}[chunkId] + ".chunk.js";
};